import { h } from 'preact'
import dayjs from 'dayjs'

import cx from '../../shared/classes'

import * as style from './calendar.css'

interface Props {
    currentDate: Date
    selectedDate: string
    daysWithAvailableAppointmentSlots: string[]
    setCurrentDate: (date: Date) => void
    onDateClick: (day: dayjs.Dayjs) => void
    getDateStatus: (day: dayjs.Dayjs) => { isDisabled: boolean; hasAvailableSlots: boolean }
}

const CalendarWeekSelector: preact.FunctionalComponent<Props> = ({
    currentDate,
    selectedDate,
    onDateClick,
    setCurrentDate,
    getDateStatus,
}) => {
    const today = new Date()
    const isLeftArrowDisabled = dayjs(today).month() === dayjs(currentDate).month()

    const nextWeek = () => {
        setCurrentDate(dayjs(currentDate).add(1, 'week').toDate())
    }

    const prevWeek = () => {
        setCurrentDate(dayjs(currentDate).add(-1, 'week').toDate())
    }

    const getDays = () => {
        const weekStart = dayjs(currentDate).startOf('week')
        const weekEnd = dayjs(currentDate).endOf('week')
        const dateFormat = 'D ddd'
        const days = []
        let day = weekStart
        let formattedDate = ''

        while (day <= weekEnd) {
            for (let i = 0; i < 7; i++) {
                const cloneDay = day
                const { isDisabled, hasAvailableSlots } = getDateStatus(day)
                formattedDate = dayjs(day).format(dateFormat)
                formattedDate = formattedDate.replace(' ', '\n')

                days.push(
                    <div
                        className={cx({
                            [style.column]: true,
                            [style.cell]: true,
                            [style.disabled]: isDisabled,
                        })}
                        key={day}
                        onClick={() => onDateClick(dayjs(cloneDay))}
                    >
                        <span
                            className={cx({
                                [style.dateNumber]: true,
                                [style.available]: hasAvailableSlots && !isDisabled,
                                [style.selected]: dayjs(day).isSame(dayjs(selectedDate), 'day'),
                            })}
                        >
                            {formattedDate}
                        </span>
                    </div>
                )
                day = dayjs(day).add(1, 'day')
            }
        }

        return days
    }

    return (
        <div className={style.row}>
            <div className={style.arrowLeft}>
                <div
                    className={cx({
                        [style.icon]: true,
                        [style.iconDisabled]: isLeftArrowDisabled,
                    })}
                    onClick={prevWeek}
                >
                    chevron_left
                </div>
            </div>
            {getDays()}
            <div className={style.arrowRight}>
                <div className={style.icon} onClick={nextWeek}>
                    chevron_right
                </div>
            </div>
        </div>
    )
}

export default CalendarWeekSelector
